import React, { Component } from 'react';
import { View, TextInput, Button, Scene, AppHeader, DatePicker, Text, Switch, TextArea, isWeb, ScrollView, FilePicker, UploadList, Link } from 'core';
import * as actions from 'actions';
import { getUploadedFiles } from 'selectors';
import { css, theme } from 'constants';
import { lang } from 'lang';
import { getDefaultDueDate } from 'utils';
import { IcoFileType, IcoTrash } from 'icons';

const styles = css({
  container: {
    paddingHorizontal: isWeb ? 70 : 20,
    paddingVertical: isWeb ? 40 : 20
  },
  column: {
    marginBottom: 30
  },
  row: {
    height: 50,
    alignItems: 'center',
    flexDirection: 'row',
    marginVertical: 10
  },
  label: {
    minWidth: 80,
    marginRight: 15,
    marginVertical: 5,
    color: theme.gray_color
  },
  row_item: {
    marginLeft: isWeb ? 20 : 10
  },
  attachments_cont: {
    flexDirection: 'row',
    marginVertical: 10,
    alignItems: 'center'
  },
  btn: {
    marginTop: 30,
    alignSelf: 'center'
  },
  field: {
    width: 'auto'
  }
});

class Task extends Component {
  constructor(props) {
    super(props);
    const task = props.task
      ? { ...props.task }
      : {
          title: '',
          description: '',
          submit: false
        };

    this.state = { ...task, show_due: task.due ? true : false, deleted_index: [] };
  }
  componentWillUnmount() {
    const { selected_group, upload_list } = this.props;
    upload_list.length && actions.markUploadFinished({ g_id: 'task', u_id: selected_group });
  }
  renderAttachment = (file, index) =>
    !this.state.deleted_index.includes(index) ? (
      <View style={{ flexDirection: 'row', paddingVertical: 5, maxWidth: 400 }} key={index}>
        <IcoFileType name={file.name} size={25} />
        <Text ellipsizeMode={'tail'} numberOfLines={1} style={{ flex: 1, color: theme.gray_color, paddingLeft: 3 }}>
          {file.name}
        </Text>
        <Link
          icon={IcoTrash}
          color={theme.primary_color}
          onPress={() => this.setState({ deleted_index: [...this.state.deleted_index, index] })}
          icon_style={{ alignSelf: 'flex-end' }}
        />
      </View>
    ) : null;

  saveTask = ({ title, edit_mode, description, show_due, due, id, submit, selected_group }) => {
    edit_mode
      ? actions.sendUpdateTask(
          {
            title,
            description,
            due: show_due ? due : null,
            submit,
            uploads: getUploadedFiles({ g_id: 'task', u_id: selected_group }),
            deleted_index: this.state.deleted_index
          },
          id,
          selected_group
        )
      : actions.sendAddTask({ title, description, due: show_due ? due : null, submit, uploads: getUploadedFiles({ g_id: 'task', u_id: selected_group }) }, selected_group);
    this.setState({ ...this.state });
  };

  _onFilesAdded = files => {
    const { selected_group } = this.props;
    actions.sendFiles({ g_id: 'task', u_id: selected_group, files });
  };

  Attachemnts = ({ attachments, upload_list, selected_group }) => (
    <View style={{ flex: 1 }}>
      {attachments ? attachments.map(this.renderAttachment) : null}
      <UploadList files={upload_list} />
      <Link
        color={theme.primary_color}
        title={lang.ADD_ATTACHMENT}
        style={{ paddingVertical: 10 }}
        onPress={() => FilePicker.show({ asset_type: FilePicker.TYPES.ALL, multiple: true }, this._onFilesAdded)}
      />
    </View>
  );
  render() {
    const { status, selected_group, edit_mode, upload_list } = this.props;
    const { id, title, description, due, show_due, submit, attachments } = this.state;

    return (
      <Scene avoidKeyboard>
        <AppHeader title={edit_mode ? lang.EDIT_TASK : lang.ADD_TASK} close />
        <Scene>
          <ScrollView style={{ flex: 1 }} contentContainerStyle={styles.container}>
            <View style={styles.column}>
              <Text style={styles.label}> {lang.TITLE} </Text>
              <TextInput onChangeText={title => this.setState({ title })} style={styles.field} value={title} />
            </View>
            <View style={styles.column}>
              <Text style={styles.label}> {lang.DESCRIPTION} </Text>
              <TextArea onChangeText={description => this.setState({ description })} min_row={3} value={description} font_size={theme.font_md} />
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{lang.DUE}</Text>
              {this.state.show_due ? <DatePicker onChangeDate={date => this.setState({ due: date })} value={this.state.due} /> : null}
              <Switch
                onValueChange={() => {
                  return this.setState({ show_due: !this.state.show_due, due: due ? due : getDefaultDueDate() });
                }}
                value={this.state.show_due}
                style={styles.row_item}
              />
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{lang.SUBMISSION}</Text>
              <Switch onValueChange={() => this.setState({ submit: !this.state.submit })} value={this.state.submit} style={styles.row_item} />
            </View>
            <View style={styles.attachments_cont}>
              <Text style={styles.label}>{lang.ATTACHMENTS}</Text>
              <this.Attachemnts attachments={attachments} upload_list={upload_list} selected_group={selected_group} />
            </View>
            <Button
              style={styles.btn}
              title={lang.SAVE}
              disabled={status.is_loading || title.trim() === ''}
              onPress={() => this.saveTask({ title, edit_mode, description, show_due, due, id, submit, selected_group })}
              status={status}
              onSuccess={() => {
                actions.fetch.markFinished(status.type);
                actions.clickCloseModal();
              }}
            />
          </ScrollView>
        </Scene>
      </Scene>
    );
  }
}

export default Task;



// WEBPACK FOOTER //
// ./src/components/modals/task.js